<template>
  <div>
    <el-form inline>
      <el-form-item label="">
        <selectCompany :filter_all="filter_all" :id.sync="condition.company_id" />
      </el-form-item>

      <el-form-item label="">
        <selectClient :client-id.sync="condition.client_id" :company-id="condition.company_id" />
      </el-form-item>

      <el-form-item label="">
        <selectMvm :id.sync="condition.mvm_id" :client-id="condition.client_id" :company-id="condition.company_id" :show_all_mvm="condition.show_all_mvm" />
      </el-form-item>

      <el-form-item v-show="!hide_payment" label="">
        <selectPayment :id.sync="condition.payment_code" />
      </el-form-item>

      <el-form-item label="">
        <selectDate @onSelect="onDateChange" />
      </el-form-item>
      <slot />
    </el-form>
  </div>
</template>
<script>
import selectCompany from '@/components/select/companies.vue';
import selectClient from '@/components/select/client.vue';
import selectMvm from '@/components/select/mvm.vue';
import selectDate from '@/components/select/datePicker.vue';
import selectPayment from '@/components/select/payment.vue';
const methods = {
  async onSelectCompany() {},
  async onSelectClient(id) {},
  async onSelectMvm() {},
  async onDateChange(date) {
    this.condition.date = date;
  },
};
export default {
  components: {
    selectCompany,
    selectClient,
    selectMvm,
    selectDate,
    selectPayment,
  },
  props: {
    hide_payment: {
      default: true,
    },
    show_all_mvm: {
      default: false,
    },
  },
  data() {
    return {
      filter_all: false,
      condition: {
        company_id: null,
        client_id: null,
        mvm_id: null,
        payment_code: null,
        date: null,
        show_all_mvm: false,
      },
    };
  },
  watch: {
    condition: {
      handler: function () {
        this.$emit('onSearch', this.condition);
      },
      deep: true,
    },
  },
  mounted() {
    this.filter_all = false;
    this.condition.show_all_mvm = this.show_all_mvm;
  },
  created() {
    if (this.condition.company_id) this.$emit('onSearch', this.condition);
  },
  methods,
};
</script>
